import { render, staticRenderFns } from "./Enquetes.vue?vue&type=template&id=dafc01fc&scoped=true&"
import script from "./Enquetes.vue?vue&type=script&lang=js&"
export * from "./Enquetes.vue?vue&type=script&lang=js&"
import style0 from "./Enquetes.vue?vue&type=style&index=0&id=dafc01fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafc01fc",
  null
  
)

export default component.exports